import { compose, curry, isEmpty, join, map, not, pick, values } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';
import { severity } from '@gef-ui/validations/constants';

export const hasRequiredValue = (requiredFields) => compose(not, isEmpty, join(''), values, pick(requiredFields));

export const toFieldState = (acc, current) => ({
	...acc,
	[current]: { valid: severity.ERROR },
});

export const trimFormData = (formData) => {
	return map((s) => {
		if (!s) {
			return s;
		} else if (typeof s === 'string') {
			return s.trim();
		} else if (s instanceof Date) {
			return s;
		} else if (typeof s === 'object') {
			return trimFormData(s);
		} else {
			return s;
		}
	}, formData);
};

export const generateRequiredLabel = curry((formName, fieldName) => `${getLabelMessage(`${formName}:${fieldName}`)}`);
